const index = () => import('@/views/Home.vue')
const fleetDetail = () => import('@/views/fleetDetail.vue')
export default [{
    path: '/',
    component: index,
    redirect: {
      name:'index'
    }
  },
  {
    path: '/index',
    component: index,
    name: 'index'
  },
  {
    path: '/fleetDetail',
    component: fleetDetail,
    name: 'fleetDetail',
    props: (route) => ({ query: route.query}) 
  },
  {
    path: '*',
    redirect: {
      name:'index'
    }
  }
]